import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { BrandThemeProvider } from './components/BrandThemeProvider'
import { AuthProvider } from './lib/AuthProvider'
import { queryClient } from './lib/queryClient'
import { captureAuthError } from './lib/authErrorParams'

// Snapshot any magic-link error (e.g. #error=access_denied&error_code=otp_expired)
// from the address bar BEFORE the router mounts and redirects to /login, which
// would otherwise strip the hash and leave the user bounced with no explanation.
captureAuthError()

// QueryClientProvider wraps the whole app so every server-state read hook
// shares one cache (config in src/lib/queryClient.ts). It sits above the
// router/Suspense boundary (which live inside <App />), so cached data
// survives route changes — the whole point of adopting React Query.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrandThemeProvider>
          <App />
        </BrandThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
